export default __webpack_public_path__ + "a1a36a8d6c804ed95ad5ce7ed838e40c.svg";